import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../styles/Testimonials.css"; // Import your custom CSS for styling

import { Avatar, Box, Card, CardContent, Typography } from "@mui/material";

import React from "react";
import Slider from "react-slick";
import defaultImage from "../../assets/ic_default_image.svg";

const TestimonialCard = (props) => {
	const testimonial = props.testimonial;
	return (
		<Box sx={{ minHeight: 436 }}>
			<Card
				className='testimonial-card'
				elevation={4}
				sx={{
					maxWidth: 320,
					minHeight: 420,
					mx: "auto",
					my: 2,
					borderRadius: 3,
					textAlign: "center",
					transition: "transform 0.4s ease, box-shadow 0.4s ease",
				}}>
				<CardContent>
					<Avatar
						src={testimonial.image || defaultImage}
						alt={testimonial.name}
						sx={{ width: 100, height: 100, mx: "auto", mb: 2 }}
					/>
					<Typography variant='h6' fontWeight={700} gutterBottom sx={{ color: "#000" }}>
						{testimonial.name}
					</Typography>
					<Typography variant='body2' sx={{ mt: 4, color: "#000" }}>
						{testimonial.text}
					</Typography>
					<Typography variant='subtitle2' sx={{ mt: 4, color: "#000" }}>
						{testimonial.role}
					</Typography>
				</CardContent>
			</Card>
		</Box>
	);
};

const Testimonials = (props) => {
	const testimonials = props.testimonials || [];
	const settings = {
		dots: true,
		infinite: true,
		centerMode: true,
		centerPadding: "0px",
		slidesToShow: 3,
		speed: 600,
		autoplay: true,
		autoplaySpeed: 2000,
		arrows: false,
		swipe: true,
		draggable: true,
		adaptiveHeight: true,
		touchThreshold: 10,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
					centerPadding: "0px",
				},
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 1,
					centerPadding: "0px",
				},
			},
		],
	};
	return (
		<div style={{ padding: "50px 20px", backgroundColor: "#f9f9f9" }}>
			<h2 style={{ textAlign: "center", marginBottom: "40px" }}>What Our Clients Say</h2>
			<Slider {...settings}>
				{testimonials.map((testimonial, index) => (
					<div key={index}>
						<TestimonialCard
							testimonial={{
								name: testimonial.ENDORSER,
								role: testimonial.PROFESSION,
								text: testimonial.REVIEW,
								image: testimonial.ENDORSER_IMG_URL,
							}}
						/>
					</div>
				))}
			</Slider>
		</div>
	);
};

export default Testimonials;
